import { Injectable } from '@angular/core'

import { Store } from '../../models/store'
import { UserDto } from '../http/dto/user.dto'
import {ChantierDto} from "../../../home/data-access/http/dto/chantier.dto";

export interface UserStateModel {
  connectedUser : UserDto
  userChantiers: ChantierDto[]
}

@Injectable({ providedIn: 'root' })
export class UserState {
    store = new Store<UserStateModel>({
      connectedUser: null,
      userChantiers: []
    })

  static getConnectedUser = (state : UserStateModel): UserDto => state.connectedUser
  static getUserChantiers = (state : UserStateModel): ChantierDto[] => state.userChantiers

}


